import React from 'react';
import { Card, Typography } from 'antd';
import { BarChartOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const REPORT_ITEMS = [
  {
    key: 'dead-chicken',
    to: '/reports/dead-chicken',
    icon: BarChartOutlined
  }
];

const ReportsIndex = () => {
  const { t } = useTranslation();

  return (
    <div className="report-page max-w-3xl mx-auto px-3 sm:px-4 py-4 sm:py-8 space-y-4 sm:space-y-6">
      <Title level={3} className="!mb-0 !text-wabi-brown-800">
        {t('report.menu.title')}
      </Title>

      <Text className="block text-gray-500">
        {t('report.menu.subtitle')}
      </Text>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {REPORT_ITEMS.map(({ key, to, icon: Icon }) => (
          <Link key={key} to={to} className="block no-underline">
            <Card
              hoverable
              className="bg-white/90 border-0 shadow-sm h-full"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-start gap-3 min-w-0">
                  <Icon className="text-2xl text-wabi-brown-600 mt-0.5 shrink-0" />
                  <div className="min-w-0">
                    <Text className="block font-semibold text-wabi-brown-800 text-base">
                      {t(`report.menu.${key}`)}
                    </Text>
                    <Text className="block text-sm text-gray-500 mt-1">
                      {t(`report.menu.${key}Desc`)}
                    </Text>
                  </div>
                </div>
                <RightOutlined className="text-gray-400 shrink-0" />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ReportsIndex;
